import Proptypes from 'prop-types'
import dynamic from 'next/dynamic'
import { isPartVisible } from 'utils/displayByDateAndTime'
import List from 'components/List'
import Selfiebooth from 'components/Selfiebooth'
import AugmentedReality from 'components/AugmentedReality'
import Map from 'components/Map'
import Puzzle from 'components/Puzzle'

export const PartPremium = ({ part, cardInfos, appInfos, visitorId, partIndex, themeInfos, isPwa = false }) => {
  if (!isPartVisible(part)) return null

  switch (part.type) {
    case 'Photobooth':
      return (
        <Selfiebooth
          cardInfos={cardInfos}
          app={appInfos}
          part={part}
          visitorId={visitorId}
        />
      )
    case 'AugmentedReality':
    case 'EnhancedReality':
      return <AugmentedReality
        cardInfos={cardInfos}
        app={appInfos}
        part={part}
        visitorId={visitorId}
        isPwa={isPwa}
      />
    case 'Map':
      return <Map part={part} />
    case 'List':
      return <List appId={appInfos.id} id={part.id} />
    case 'Puzzle':
      return <Puzzle src={part.url} title={part.title} success={part.success} legend={part.legend} legendSize={part.legendSize} />
    default:
      return null
  }
}

PartPremium.propTypes = {
  appInfos: Proptypes.object,
  cardInfos: Proptypes.object,
  part: Proptypes.object,
  partIndex: Proptypes.number,
  visitorId: Proptypes.any,
  themeInfos: Proptypes.object,
}

export default PartPremium
